import { Outlet } from 'react-router-dom';
import { WbNotificationHost } from '@workbench/react';
import './Layout.scss';
import Header from './Header/Header';
import Footer from './Footer/Footer';

function Layout() {
	return (
		<div className="App">
			<header>
				<Header />
			</header>
			<main>
				<Outlet />
			</main>
			<footer>
				<Footer />
			</footer>
			<WbNotificationHost />
		</div>
	);
}

export default Layout;
